import React, { Component } from 'react';
import { VerificationForm } from '@sheerid/jslib';
import './App.css';

class App extends Component {
  render() {
    window.parent.postMessage(JSON.stringify({
      action: "updateHeight",
      height: 650,
    }), "*");

    return (
      <div className="sid-page">
        <div className="sid-page__columns">
          <div className="sid-page__form sid-page__column">
            <VerificationForm programId="5d5c41d2fff6fc1f82cf2ed3" />
          </div>
        </div>
      </div>
    );
  }
}

export default App;
